import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    {
      title: '影视分类',
      links: [
        { name: '动作片', path: '/category/action' },
        { name: '喜剧片', path: '/category/comedy' },
        { name: '爱情片', path: '/category/romance' },
        { name: '科幻片', path: '/category/scifi' },
        { name: '恐怖片', path: '/category/horror' },
        { name: '剧情片', path: '/category/drama' },
      ],
    },
    {
      title: '热门推荐',
      links: [
        { name: '最新电影', path: '/category/all' },
        { name: '电视剧大全', path: '/category/tv' },
        { name: '热门综艺', path: '/category/variety' },
        { name: '动漫精选', path: '/category/animation' },
        { name: '高分榜单', path: '/category/drama' },
        { name: '本周热播', path: '/category/all' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { name: '品牌介绍', path: '/about' },
        { name: '联系方式', path: '/about#contact' },
        { name: '常见问题', path: '/about#faq' },
        { name: '版权声明', path: '/about' },
        { name: '合作洽谈', path: '/about#contact' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-2xl font-bold text-primary-500 tracking-wider">
                7777<span className="text-foreground-50">影院</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              7777影院提供海量高清电影、电视剧、综艺动漫免费在线观看服务。每日更新，播放流畅不卡顿。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-base"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 7777影院 777777影院 版权所有 | 免费电影高清在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}